export default __webpack_public_path__ + "media/images/icons/3-flight-ae1cc98ac7bc331e57f8b83597754bac.png";